import { Component, OnChanges, OnInit } from '@angular/core';
import { EventsGroupComponent } from '../../events-group/events-group.component';

@Component({
  selector: 'app-events-group-mobile',
  templateUrl: './events-group-mobile.component.html',
  styleUrls: ['./events-group-mobile.component.less']
})
export class EventsGroupMobileComponent extends EventsGroupComponent implements OnChanges {
  ngOnChanges() {
    if (this.eventsGroupVM && this.eventsGroupVM.betTypeGroups[0] && this.eventsGroupVM.betTypeGroups[0].betTypeGroupingTemplateItems[0]) {
      this.setSelectedBetTypeGroup({
        betTypeGroup: this.eventsGroupVM.betTypeGroups[0],
        betTypeGroupingTemplateItems: [this.eventsGroupVM.betTypeGroups[0].betTypeGroupingTemplateItems[0]]
      });
    }
  }
}
